import { postRequest } from '../requests';

export interface DeviceInfoProperties {
    Browser?: string;
    BrowserVersion?: string;
    OperatingSystem?: string;
    Resolution?: string;
    Device?: string;
    DeviceType?: string;
}

export interface DeviceInfo {
    identifier: string;
    platform: 'Web';
    properties: DeviceInfoProperties;
}

export interface CaptureDevicePayload {
    offset: string;
    device: DeviceInfo;
    timeZone: string;
}

export function captureParticipantDevice(payload: CaptureDevicePayload) {
    return postRequest('api/researchkit/studyparticipant/captureparticipantdevice/', payload);
}
